import { render } from "./SiteLayout.vue?vue&type=template&id=6182dfdd"
import script from "./SiteLayout.vue?vue&type=script&lang=js"
export * from "./SiteLayout.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/kinofarm-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__